import { useTranslation } from "react-i18next";
import { AppButton } from "@/shared/Components";
import { EditIcon } from "@/shared/icons";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  onClick?: () => void;
  disabled?: boolean;
};

export const EditConnectionsButton: FC<Props> = ({ disabled, onClick }) => {
  const { t } = useTranslation();

  return (
    <AppButton className={styles["edit-connections-button"]} onClick={onClick} disabled={disabled}>
      <EditIcon />
      {t("common.editSelected")}
    </AppButton>
  );
};
